import { createAction, createRequestActions } from "common/helpers/action";

export const setUserCompany = createAction("ACCOUNT.SET_USER_COMPANY");
export const changeCompany = createRequestActions("ACCOUNT.CHANGE_COMPANY");
export const logout = createRequestActions("ACCOUNT.LOGOUT");
